export type PrintifyAccount = {
  brandId: string
  printifyShopCount?: number
  firstPrintifyShopTitle?: string
  status: 'connected' | 'error'
}

export type PrintifyHealth = {
  accounts: PrintifyAccount[]
}

function printifyHealthUrl(brandId?: string) {
  const q = brandId ? `?brandId=${encodeURIComponent(brandId)}` : ''
  return `/api/printify/health${q}`
}

/** When `brandId` is set (brand Settings), returns at most one account for that brand. */
export async function getPrintifyHealth(brandId?: string): Promise<PrintifyHealth> {
  const res = await fetch(printifyHealthUrl(brandId))
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}

export async function connectPrintifyAccount(
  token: string,
  brandId: string,
): Promise<{ success: true; brandId: string }> {
  const res = await fetch('/api/printify/connect', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, brandId }),
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.message || data.error || `HTTP ${res.status}`)
  return data
}

export async function disconnectPrintifyAccount(brandId: string): Promise<void> {
  const res = await fetch('/api/printify/disconnect', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ brandId }),
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.message || data.error || `HTTP ${res.status}`)
}
